import { render, staticRenderFns } from "./SearchScreen.vue?vue&type=template&id=4d5a7dfa&"
import script from "./SearchScreen.vue?vue&type=script&lang=ts&"
export * from "./SearchScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports